import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { StoreModelType, TableResourceType } from '@smx-ui-model/types';

export interface InspectorStateProps {
    currentEntityList: TableResourceType[];
    nameNewEntity?: keyof StoreModelType;
    isCloseAll: boolean;
    parentNode?: any;
    parentData?: { [key: string]: any };
    parentModelName?: string;
}

const initialState: InspectorStateProps = {
    currentEntityList: [],
    isCloseAll: false,
};

export const inspectorSlice: Slice<InspectorStateProps> = createSlice({
    name: 'inspector',
    initialState,
    reducers: {
        setterInspector: (state, action: PayloadAction<Partial<InspectorStateProps>>) => ({
            ...state,
            ...action.payload,
        }),
        setCurrentModel: (state, action: PayloadAction<TableResourceType>) => {
            if (!state.currentEntityList.find((entity) => entity.key === action.payload.key)) {
                state.currentEntityList.push(action.payload);
            }
        },
        deleteCurrentModel: (state, action: PayloadAction<string>) => {
            state.currentEntityList = state.currentEntityList.filter((entity) => entity.key !== action.payload);
        },
        setManyModel: (state, action: PayloadAction<TableResourceType[]>) => {
            state.currentEntityList = action.payload;
        },
    },
    extraReducers: () => {},
});

// Action creators are generated for each case reducer function
export const { setCurrentModel, deleteCurrentModel, setterInspector, setManyModel, setStoreConnectionId } =
    inspectorSlice.actions;

export default inspectorSlice.reducer;
